<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let fillColor = "fill-white";
    export let strokeColor = "stroke-white";
    export let hover = "group-hover/btn-emoji:fill-white";
    export let classList = "aspect-ratio transition-all";
</script>

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="{height} {width} {strokeColor} {fillColor} {classList} {hover} icon icon-tabler icons-tabler-filled icon-tabler-hat"
>
    <g clip-path="url(#clip0_829_87)">
        <path
            d="M20 3C20.5523 3.00004 21 3.44774 21 4V9C21 9.30843 20.8576 9.5996 20.6143 9.78906L12.5068 16.0928L13.207 16.793L13.2754 16.8691C13.5957 17.2619 13.5731 17.8409 13.207 18.207C12.8409 18.5731 12.2619 18.5957 11.8691 18.2754L11.793 18.207L10.999 17.4131L7.70703 20.707C7.31652 21.0975 6.6835 21.0975 6.29297 20.707L3.29297 17.707C2.90244 17.3165 2.90244 16.6835 3.29297 16.293L6.58496 12.999L5.79297 12.207C5.40244 11.8165 5.40244 11.1835 5.79297 10.793C6.1835 10.4025 6.81652 10.4025 7.20703 10.793L7.90527 11.4912L14.2109 3.38574L14.2861 3.2998C14.473 3.10924 14.7299 3 15 3H20ZM9.33105 12.917L11.082 14.668L19 8.51074V5H15.4893L9.33105 12.917Z"
            fill="currentColor"
        />
        <path
            d="M17.707 6.91732C17.707 6.97036 17.686 7.02123 17.6485 7.05874L10.0473 14.6599C10.0187 14.6885 9.97563 14.6971 9.93826 14.6816L9.53826 14.5159C9.51376 14.5057 9.4943 14.4862 9.48415 14.4617L9.31854 14.0619C9.30306 14.0245 9.31162 13.9815 9.34022 13.9529L16.9414 6.35169C16.9789 6.31419 17.0298 6.29312 17.0828 6.29311L17.507 6.29301C17.6175 6.29299 17.707 6.38254 17.707 6.49301V6.91732Z"
            fill="currentColor"
        />
    </g>
    <defs>
        <clipPath id="clip0_829_87">
            <rect width="24" height="24" fill="currentColor" />
        </clipPath>
    </defs>
</svg>
